// extracted by mini-css-extract-plugin
export default {"title":"title--1PQM-","price":"price--318-r"};